import { useState } from "react";
import { Loader2, LogIn, Lock } from "lucide-react";
import { Button } from "../ui/button";
import { errorText } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { EmailInput, FormError, PasswordInput } from "./Fields";
import { StepTitle } from "./LoginShell";

export const PasswordSignIn = ({ gated, onNext, onForgot, email, setEmail }) => {
  const { login, openAuth } = useAuth();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      onNext(await login(email.trim(), password));
    } catch (err) {
      setError(errorText(err, "Sign-in didn't work. Please try again."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="login-form">
      {gated ? (
        <StepTitle title="Something quacky is on its way.">
          We're putting the finishing touches on the studio. Invited partners and the Duckify team can sign in below.
        </StepTitle>
      ) : (
        <StepTitle title="Sign in to Duckify">Use the email and password for your account.</StepTitle>
      )}
      {gated && (
        <p data-testid="login-invite-note" className="flex items-center gap-2 rounded-2xl bg-[#1f1f24] px-4 py-3 text-sm font-semibold text-white">
          <Lock className="h-4 w-4 shrink-0 text-[#ffc700]" /> Duckify is invite-only for now.
        </p>
      )}
      <EmailInput value={email} onChange={setEmail} />
      <PasswordInput id="login-password" testid="login-password-input" value={password} onChange={setPassword} />
      <FormError text={error} />
      <Button data-testid="login-submit-btn" type="submit" disabled={busy || !email.trim() || !password} className="h-12 w-full rounded-full font-bold gap-2 transition-transform active:scale-[0.98]">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogIn className="h-4 w-4" />} Sign in
      </Button>
      <button type="button" data-testid="login-forgot-link" onClick={onForgot} className="w-full text-center text-sm font-medium text-[#5a554b] underline-offset-4 transition-colors hover:text-[#1f1f24] hover:underline">
        First time with a password? / Forgot it?
      </button>
      {!gated && (
        <button type="button" data-testid="login-code-link" onClick={openAuth} className="w-full text-center text-xs text-[#6b6b73] underline-offset-4 hover:underline">
          Or get a one-time code by email instead
        </button>
      )}
    </form>
  );
};
